import { Box, Button, SxProps, Typography } from '@mui/material';
import { DynamicArrow } from 'Components/DynamicArrow';
import { ButtonVariants, TypographyVariants } from 'ThemeV2.0';

interface IArrowButton {
  onClick?: () => void;
  text: string;
  arrowColor?: string;
  arrowPosition?: 'left' | 'right';
  buttonVariant?: ButtonVariants;
  typographyVariant?: TypographyVariants;
  typographySx?: SxProps;
  sx?: SxProps;
}
export const ArrowButton = ({
  onClick,
  text,
  buttonVariant,
  typographyVariant,
  arrowColor = '#000',
  arrowPosition = 'left',
  typographySx,
  sx,
}: IArrowButton) => {
  return (
    <Button
      onClick={onClick}
      variant={buttonVariant}
      sx={{
        gap: '5px',
        ':focus': {
          outline: '1px solid black',
        },
        ...sx,
      }}
    >
      {arrowPosition === 'right' && (
        <Box position={'relative'} top={'5px'}>
          <DynamicArrow color={arrowColor} rotate={-90} size={20} />
        </Box>
      )}
      <Typography sx={typographySx} variant={typographyVariant}>
        {text}
      </Typography>
      {arrowPosition === 'left' && (
        <Box position={'relative'} top={'5px'}>
          <DynamicArrow color={arrowColor} rotate={90} size={20} />
        </Box>
      )}
    </Button>
  );
};
